import bitterling from './img/fish/bitterling.png';
import pale_chub from './img/fish/pale_chub.png';
import crucian_carp from './img/fish/crucian_carp.png';
import dace from './img/fish/dace.png';
import carp from './img/fish/carp.png';
import koi from './img/fish/koi.png';
import goldfish from './img/fish/goldfish.png';
import pop_eyed_goldfish from './img/fish/pop-eyed_goldfish.png';
import ranchu_goldfish from './img/fish/ranchu_goldfish.png';
import killifish from './img/fish/killifish.png';
import crawfish from './img/fish/crawfish.png';
import soft_shelled_turtle from './img/fish/soft-shelled_turtle.png';
import snapping_turtle from './img/fish/snapping_turtle.png';
import tadpole from './img/fish/tadpole.png';
import frog from './img/fish/frog.png';
import freshwater_goby from './img/fish/freshwater_goby.png';
import loach from './img/fish/loach.png';
import catfish from './img/fish/catfish.png';
import giant_snakehead from './img/fish/giant_snakehead.png';
import bluegill from './img/fish/bluegill.png';
import yellow_perch from './img/fish/yellow_perch.png';
import black_bass from './img/fish/black_bass.png';
import tilapia from './img/fish/tilapia.png';
import pike from './img/fish/pike.png';
import pond_smelt from './img/fish/pond_smelt.png';
import sweetfish from './img/fish/sweetfish.png';
import cherry_salmon from './img/fish/cherry_salmon.png';
import char from './img/fish/char.png';
import golden_trout from './img/fish/golden_trout.png';
import stringfish from './img/fish/stringfish.png';
import salmon from './img/fish/salmon.png';
import king_salmon from './img/fish/king_salmon.png';
import mitten_crab from './img/fish/mitten_crab.png';
import guppy from './img/fish/guppy.png';
import nibble_fish from './img/fish/nibble_fish.png';
import angelfish from './img/fish/angelfish.png';
import betta from './img/fish/betta.png';
import neon_tetra from './img/fish/neon_tetra.png';
import rainbowfish from './img/fish/rainbowfish.png';
import piranha from './img/fish/piranha.png';
import arowana from './img/fish/arowana.png';
import dorado from './img/fish/dorado.png';
import gar from './img/fish/gar.png';
import arapaima from './img/fish/arapaima.png';
import saddled_bichir from './img/fish/saddled_bichir.png';
import sturgeon from './img/fish/sturgeon.png';
import sea_butterfly from './img/fish/sea_butterfly.png';
import seahorse from './img/fish/seahorse.png';
import clownfish from './img/fish/clownfish.png';
import surgeonfish from './img/fish/surgeonfish.png';
import butterfly_fish from './img/fish/butterfly_fish.png';
import napoleonfish from './img/fish/napoleonfish.png';
import zebra_turkeyfish from './img/fish/zebra_turkeyfish.png';
import blowfish from './img/fish/blowfish.png';
import puffer_fish from './img/fish/puffer_fish.png';
import anchovy from './img/fish/anchovy.png';
import horse_mackerel from './img/fish/horse_mackerel.png';
import barred_knifejaw from './img/fish/barred_knifejaw.png';
import sea_bass from './img/fish/sea_bass.png';
import red_snapper from './img/fish/red_snapper.png';
import dab from './img/fish/dab.png';
import olive_flounder from './img/fish/olive_flounder.png';
import squid from './img/fish/squid.png';
import moray_eel from './img/fish/moray_eel.png';
import ribbon_eel from './img/fish/ribbon_eel.png';
import tuna from './img/fish/tuna.png';
import blue_marlin from './img/fish/blue_marlin.png';
import giant_trevally from './img/fish/giant_trevally.png';
import mahi_mahi from './img/fish/mahi-mahi.png';
import ocean_sunfish from './img/fish/ocean_sunfish.png';
import ray from './img/fish/ray.png';
import saw_shark from './img/fish/saw_shark.png';
import hammerhead_shark from './img/fish/hammerhead_shark.png';
import great_white_shark from './img/fish/great_white_shark.png';
import whale_shark from './img/fish/whale_shark.png';
import suckerfish from './img/fish/suckerfish.png';
import football_fish from './img/fish/football_fish.png';
import oarfish from './img/fish/oarfish.png';
import barreleye from './img/fish/barreleye.png';
import coelacanth from './img/fish/coelacanth.png';

export const fishData = [
  { name: "Bitterling", image: bitterling },
  { name: "Pale Chub", image: pale_chub },
  { name: "Crucian Carp", image: crucian_carp },
  { name: "Dace", image: dace },
  { name: "Carp", image: carp },
  { name: "Koi", image: koi },
  { name: "Goldfish", image: goldfish },
  { name: "Pop Eyed Goldfish", image: pop_eyed_goldfish },
  { name: "Ranchu Goldfish", image: ranchu_goldfish },
  { name: "Killifish", image: killifish },
  { name: "Crawfish", image: crawfish },
  { name: "Soft Shelled Turtle", image: soft_shelled_turtle },
  { name: "Snapping Turtle", image: snapping_turtle },
  { name: "Tadpole", image: tadpole },
  { name: "Frog", image: frog },
  { name: "Freshwater Goby", image: freshwater_goby },
  { name: "Loach", image: loach },
  { name: "Catfish", image: catfish },
  { name: "Giant Snakehead", image: giant_snakehead },
  { name: "Bluegill", image: bluegill },
  { name: "Yellow Perch", image: yellow_perch },
  { name: "Black Bass", image: black_bass },
  { name: "Tilapia", image: tilapia },
  { name: "Pike", image: pike },
  { name: "Pond Smelt", image: pond_smelt },
  { name: "Sweetfish", image: sweetfish },
  { name: "Cherry Salmon", image: cherry_salmon },
  { name: "Char", image: char },
  { name: "Golden Trout", image: golden_trout },
  { name: "Stringfish", image: stringfish },
  { name: "Salmon", image: salmon },
  { name: "King Salmon", image: king_salmon },
  { name: "Mitten Crab", image: mitten_crab },
  { name: "Guppy", image: guppy },
  { name: "Nibble Fish", image: nibble_fish },
  { name: "Angelfish", image: angelfish },
  { name: "Betta", image: betta },
  { name: "Neon Tetra", image: neon_tetra },
  { name: "Rainbowfish", image: rainbowfish },
  { name: "Piranha", image: piranha },
  { name: "Arowana", image: arowana },
  { name: "Dorado", image: dorado },
  { name: "Gar", image: gar },
  { name: "Arapaima", image: arapaima },
  { name: "Saddled Bichir", image: saddled_bichir },
  { name: "Sturgeon", image: sturgeon },
  { name: "Sea Butterfly", image: sea_butterfly },
  { name: "Sea Horse", image: seahorse },
  { name: "Clown Fish", image: clownfish },
  { name: "Surgeonfish", image: surgeonfish },
  { name: "Butterfly Fish", image: butterfly_fish },
  { name: "Napoleonfish", image: napoleonfish },
  { name: "Zebra Turkeyfish", image: zebra_turkeyfish },
  { name: "Blowfish", image: blowfish },
  { name: "Puffer Fish", image: puffer_fish },
  { name: "Anchovy", image: anchovy },
  { name: "Horse Mackerel", image: horse_mackerel },
  { name: "Barred Knifejaw", image: barred_knifejaw },
  { name: "Sea Bass", image: sea_bass },
  { name: "Red Snapper", image: red_snapper },
  { name: "Dab", image: dab },
  { name: "Olive Flounder", image: olive_flounder },
  { name: "Squid", image: squid },
  { name: "Moray Eel", image: moray_eel },
  { name: "Ribbon Eel", image: ribbon_eel },
  { name: "Tuna", image: tuna },
  { name: "Blue Marlin", image: blue_marlin },
  { name: "Giant Trevally", image: giant_trevally },
  { name: "Mahi Mahi", image: mahi_mahi },
  { name: "Ocean Sunfish", image: ocean_sunfish },
  { name: "Ray", image: ray },
  { name: "Saw Shark", image: saw_shark },
  { name: "Hammerhead Shark", image: hammerhead_shark },
  { name: "Great White Shark", image: great_white_shark },
  { name: "Whale Shark", image: whale_shark },
  { name: "Suckerfish", image: suckerfish },
  { name: "Football Fish", image: football_fish },
  { name: "Oarfish", image: oarfish },
  { name: "Barreleye", image: barreleye },
  { name: "Coelacanth", image: coelacanth },
];

export default fishData;